export class GetPendingRequestList {
    constructor(pendingRequestRepository) {
      this.pendingRequestRepository = pendingRequestRepository;
    }
  
    async execute(popupData) {
      return await this.pendingRequestRepository.GetPendingRequestList(popupData);
    }
  }